module.exports = __webpack_public_path__ + "fonts/Reckoner.38a26245.ttf";